export const pogAgentEn = {
  title: "Fix with AI",
  reviewCopy: {
    details: "Details",
    returnToSaved: "Return to saved",
    partialSearch: "The search stopped before testing every option. A fix may still be possible.",
    previewReady: "Preview ready. Review the changes below before applying.",
    whyFix: "Why this fix",
    cappingChanged: "Capping orientation changed",
    sideCaps: "side caps",
    topCaps: "top caps",
    rearCaps: "rear caps",
    preview: "Preview",
    answer: "Answer",
    saved: "Saved",
  },
  close: "Close Fix with AI",
  target: "Merchflow {{merchflowId}} · Store {{storeCode}} · POG {{storePogId}}",
  intro:
    "Ask for a change to this planogram, or a question about it. Changes are previewed first; " +
    "you choose whether to apply them to this store, and then to every store in the merchflow.",
  working: "Working on it...",
  applying: "Applying… {{done}} of {{total}} planograms written",
  banner: {
    previewOnCanvas:
      "The planogram shows this preview as an unsaved change. Revert to get the saved layout back.",
    blocked: "Save or revert your changes first — the agent works on the saved planogram.",
  },
  composer: {
    placeholder: "Describe the change, e.g. move item 210416 to the end of its shelf",
    hint: "AI proposes changes first. Saving a fix is a separate step.",
    send: "Send",
  },
  actions: {
    applyPog: "Apply to this store POG",
    applyPogAsNew: "Apply as new version",
    applyMerchflow: "Apply to all stores in merchflow (latest POG)",
    retryPog: "Retry apply to this store POG",
    resumeMerchflow: "Resume apply from planogram {{next}} of {{total}}",
    showOnCanvas: "Show on planogram",
    onCanvas: "On the planogram",
    rerun: "Re-run preview",
  },
  mode: {
    preview: "preview",
    apply: "apply",
  },
  scope: {
    pog: "this store POG",
    merchflow: "whole merchflow",
  },
  card: {
    noMessage: "(no message)",
    model: "model: {{model}}",
    stale:
      "The planogram was saved after this preview was made, so the preview no longer matches " +
      "the saved layout. Re-run it to see the change on the current planogram.",
    stoppedEarly:
      "Stopped after {{done}} of {{total}} planograms: {{error}} Everything above was written; " +
      "resume to finish the rest without repeating it.",
    mergedSummary: "Applied to {{total}} planograms: {{parts}}.",
  },
  intent: {
    postprocess: "Edit",
    qa: "Question",
    diagnose: "Diagnosis",
  },
  picker: {
    question:
      "I could not tell whether that is a change to the planogram or a question about it. Which is it?",
    postprocess: "Edit the planogram",
    qa: "Ask a question",
    diagnose: "Diagnose (coming soon)",
  },
  diff: {
    none: "No layout changes.",
    change: "{{count}} layout change",
    changes: "{{count}} layout changes",
    showAll: "Show all {{count}}",
    showLess: "Show less",
    position: "position {{from}} → {{to}}",
    shelf: "shelf {{from}} → {{to}}",
    addedToShelf: "added to shelf {{shelf}}",
    removedFromShelf: "removed from shelf {{shelf}}",
    facings: "facings {{from}} → {{to}}",
    rows: "rows {{from}} → {{to}}",
    orientation: "orientation {{from}} → {{to}}",
    squeezeWidth: "squeeze width {{from}} → {{to}}",
    squeezeHeight: "squeeze height {{from}} → {{to}}",
    squeezeDepth: "squeeze depth {{from}} → {{to}}",
    default: "default",
    on: "on",
    off: "off",
    updated: "updated",
  },
  results: {
    written: "written",
    newCreated: "saved as a new POG",
    skipped: "skipped — no change",
    failed: "failed",
    store: "Store {{storeCode}}",
    summary: "{{parts}} of {{total}} planograms",
    countWritten: "{{count}} written",
    countNewCreated: "{{count}} saved as new",
    countSkipped: "{{count}} skipped",
    countFailed: "{{count}} failed",
    showAll: "Show all {{count}}",
    showLess: "Show less",
  },
  errors: {
    agent: "Agent error ({{status}}): {{detail}}",
    unreachable: "Could not reach the POG agent: {{detail}}",
    batchStalled: "The agent's apply batch did not advance; stopping to avoid a loop.",
    drawFailed: "Could not draw this layout: {{detail}}",
  },
  page: {
    openAgent: "POG Agent",
    replaceTitle: "Replace the planogram with the agent's version?",
    replaceDescription:
      "The agent works from the saved planogram and cannot see the changes you made on top of " +
      "its preview. Those changes will be lost.",
    keepMyChanges: "Keep My Changes",
    replace: "Replace",
  },
  embedded: {
    title: "Fix with AI",
    context: "AI uses the current plan and selected bay. Changes stay with this store.",
    emptyTitle: "What would you like to change?",
    emptyBody: "Describe a change to this planogram. You can review the proposal before saving.",
    emptyExample: "Example: “Keep the product order and fill gaps using side caps.”",
    introPreviewOnly: "Describe what to change. Compare the proposed layout before saving a fix.",
    intro:
      "Describe what you want to change, or ask about this plan. Review a preview before applying a fix.",
    failure: {
      unreachable: "AI could not connect. Retry when the local service is available.",
      planChanged: "The saved plan changed. Reload it, then request the fix again.",
      session: "Your session needs refreshing. Reload the page and try again.",
      generic: "AI could not prepare this fix. Try again or describe the change another way.",
    },
  },
};

export type PogAgentTranslations = typeof pogAgentEn;
